<template>
  <a-upload
    class="import-btn-u"
    :showUploadList="false"
    :customRequest="handleUpload"
    :beforeUpload="beforeUpload"
  >
    <div class="import-btn-btn">
      <a-button
        type="primary"
        :disabled="loading || confirmLoading"
        ghost
        class="btn-blue"
        icon="cloud-upload"
      >
        {{ btnText }}
      </a-button>
    </div>
  </a-upload>
</template>
<script>
export default {
  props: {
    btnText: {
      type: String,
      default: "导入",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    businessType: {
      type: String,
      default: "",
    },
    fileType: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      confirmLoading: false,
    };
  },
  methods: {
    // 上传返回
    handleUpload(data) {
      this.confirmLoading = true;
      this.common.uploadLocalFiles(data, this.businessType).then(res => {
        this.back(res);
        this.confirmLoading = false;
      });
    },
    beforeUpload(file) {
      if (this.fileType.length) {
        return this.common.beforeUpload(file, this.fileType);
      }
    },
    back(data) {
      this.$emit("uploadOk", data);
    },
  },
};
</script>
<style lang="less"></style>
